import React from 'react';
import DirectusSDK from '@directus/sdk-js';
import HeadlessConfig from '../config/headless';
import ContactForm from '../components/contact_form';
import { Link } from 'react-router-dom';

import "./d_gesuche.css";

const client = new DirectusSDK();
client.login({
  url: HeadlessConfig.url,
  project: HeadlessConfig.project,
  email: HeadlessConfig.email,
  password: HeadlessConfig.password
});

export default class GesuchDetailView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      uuid: this.props.match.params.id,
      item: {},
      isLoaded: false
    }
  }

  componentWillMount() {
    client.getItem('bnb_angebote',this.state.uuid).then(data => {
      this.setState({item: data.data, isLoaded: true});
    }).catch(err => {
      console.error(err);
    })
  }


  convertBinaryToString(binary) {
    if(binary == 1) return "Ja";
    if(binary == 0) return "Nein";
  }

  render() {

    const {uuid, item} = this.state;

    return (
      <div>
        <div className={'d_header'}>
          <Link to="/" className={'go_back_link'}>Zurück zur Übersicht</Link>
        </div>
        <div className={'detail_view'}>
          <div className={'left_view'}>
            <h1>{item.headline}</h1>
            <div className={'about_text'}>
              <div>
                <strong>Über uns/über mich</strong>
                <p>{item.about}</p>
              </div>
            </div>
            <div className={'table_view'}>
              <div>
                <p>Benötigte Schlafplätze</p>
                <p>{item.number}</p>
              </div>
              <div>
                <p>Bringe Kinder mit</p>
                <p>{this.convertBinaryToString(item.kids)}</p>
              </div>
              <div>
                <p>Benötige Barrierefreiheit</p>
                <p>{this.convertBinaryToString(item.accessible)}</p>
              </div>
            </div>
          </div>
          <div className={'right_view'}>
            <ContactForm uuid={uuid} type={"bnb_gesuche_kontakt"} inserat={this.state.item} />
          </div>
        </div>
      </div>
      );
  }
}